<template>
  <v-layout column>
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text :disabled="!activeCampaign.name" @click="onSave()" color="primary"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVE') }}</v-btn><br /><!-- mdi-content-save-outline -->
        <v-btn text disabled><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVEAS') }}</v-btn><br /><!-- mdi-content-save-settings-outline -->
        <v-btn text disabled color="red darken-1"><v-icon>mdi-trash-can-outline</v-icon>&nbsp;{{ $t('GENERIC_DELETE') }}</v-btn><br />
        <v-btn text :disabled="!dirty" @click="editCampaign(activeCampaign.campaign_id || 'new')"><v-icon>mdi-close-box-outline</v-icon>&nbsp;{{ $t('GENERIC_DISCARD') }}</v-btn><br />
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>

      <v-card>
        <v-card-text>
<v-sheet v-if="debug">{{ activeCampaign }}</v-sheet>
          <v-alert>
            {{ $t('CAMPAING_DISPATCH_OUTSIDE_WARN') }}
          </v-alert>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="activeCampaign.name"
                    :label="$t('CAMPAIGN_NAME')"
                    @change="dirty=true"
                    :rules="[value => value.length <= 255 || 'Max 255 characters']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 text-xs-right>
                </v-flex>
                <v-flex xs12>
                  <v-sheet color="grey lighten-3">
                    <v-layout wrap>
                      <v-flex>
                        <!-- TODO: i18n -->
                        <v-daterange
                          v-model="range"
                          :display-format="$t('LOCALE_DATE_RANGE_FORMAT')"
                          :input-props="{ label: $t('CAMPAIGN_RANGE'), class: 'campaign-range' }"
                          :menu-props="{ 'min-width': 400 }"
                          :start-label="$t('LOCALE_DATE_RANGE_FORMAT')"
                          :end-label="$t('LOCALE_DATE_RANGE_FORMAT')"
                          separator-label="-"
                          @input="dirty=true"
                        ></v-daterange>
                      </v-flex>
                    </v-layout>
                  </v-sheet>
                </v-flex>
                <v-flex xs12 v-if="activeCampaign.campaign_id">
                  <v-sheet color="grey lighten-2">
                    <v-layout wrap>
                      <v-flex>
                        <v-chip label>{{ $t('CAMPAIGN_NUM_MAILINGS') }} : {{ activeCampaign.num_mailings }}</v-chip>
                        <v-chip label>{{ $t('CAMPAIGN_NUM_PRINTMAILINGS') }} : {{ activeCampaign.num_cmp_actions }}</v-chip>
                        <v-chip label>{{ $t('CAMPAIGN_FIRST_DISPATCH') }} : {{ first_dispatch_datetime | moment($t('LOCALE_DATE_FORMAT')) }}</v-chip>
                        <v-chip label>{{ $t('CAMPAIGN_LAST_DISPATCH') }} : {{ last_dispatch_datetime | moment($t('LOCALE_DATE_FORMAT')) }}</v-chip>
                      </v-flex>
                    </v-layout>
                  </v-sheet>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

    <Dialog ref="dialog" />

  </v-layout>
</template>

<script>
import { dateToISO, dateToISODate } from '../helpers/filters'
import { mapGetters } from 'vuex';
import Dialog from './common/Dialog'
import Campaign from '../services/Campaign';
import Folder from '../services/Folder';
import VDaterange from './common/VDaterange';

export default {
  name: 'CampaignView',
  components: {
    Dialog,
    VDaterange,
  },
  props: ['id', 'refToolbar'],
  data() {
    return {
      debug: false,
      dirty: false,
      range: {
        start: null,
        end: null,
      },
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'activeCampaign', 'selectedCampaignFolder']),
    first_dispatch_datetime() {
      const oldest_mailing_datetime = this.activeCampaign.oldest_mailing_date ? new Date(dateToISO(this.activeCampaign.oldest_mailing_date)).getTime() : 0
      const oldest_cmp_action_datetime = this.activeCampaign.oldest_cmp_action_date ? new Date(dateToISO(this.activeCampaign.oldest_cmp_action_date)).getTime() : 0
// console.log(oldest_cmp_action_datetime)
      return oldest_mailing_datetime && oldest_cmp_action_datetime ? Math.min(oldest_mailing_datetime, oldest_cmp_action_datetime) : Math.max(oldest_mailing_datetime, oldest_cmp_action_datetime)
    },
    // first_dispatch_date() {
    //   return this.$moment(this.first_dispatch_datetime).format(this.$t('LOCALE_DATE_FORMAT'))
    // },
    last_dispatch_datetime() {
      const most_recent_mailing_date = this.activeCampaign.most_recent_mailing_date ? new Date(dateToISO(this.activeCampaign.most_recent_mailing_date)).getTime() : 0
      const most_recent_cmp_action_date = this.activeCampaign.most_recent_cmp_action_date ? new Date(dateToISO(this.activeCampaign.most_recent_cmp_action_date)).getTime() : 0
      return Math.max(most_recent_mailing_date, most_recent_cmp_action_date)
    },
    // last_dispatch_date() {
    //   return this.$moment(this.last_dispatch_datetime).format(this.$t('LOCALE_DATE_FORMAT'))
    // },
//     range: {
//       get() {
// console.log('get', this.activeCampaign.start_date, this.activeCampaign.end_date)
//         return {
//           start: dateToISODate(this.activeCampaign.start_date),
//           end: dateToISODate(this.activeCampaign.end_date),
//         }
//       },
//       set(val) {
// console.log('set', val, val.start.replace(/-/g, '') + '00:00:00', val.end.replace(/-/g, '') + '23:59:59')
//         this.activeCampaign.start_date = val.start.replace(/-/g, '') + '00:00:00'
//         this.activeCampaign.end_date = val.end.replace(/-/g, '') + '23:59:59'
//       },
//     }
  },
  watch: {
    id(val) {
      this.editCampaign(val)
    },
    activeCampaign() {
      this.$nextTick(() => {
        this.dirty = false
      })
      this.range = {
        start: dateToISODate(this.activeCampaign.start_date),
        end: dateToISODate(this.activeCampaign.end_date),
      }
    },
    'activeCampaign.start_date'(val) {
      this.range.start = dateToISODate(val)
    },
    'activeCampaign.end_date'(val) {
      this.range.end = dateToISODate(val)
    },
    range(val) {
      this.activeCampaign.start_date = val.start ? val.start.replace(/-/g, '') + '00:00:00' : ''
      this.activeCampaign.end_date = val.end ? val.end.replace(/-/g, '') + '23:59:59' : ''
    },
  },
  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    if (this.id) {
      this.editCampaign(this.id)
    }
  },
  methods: {
    editCampaign(id) {
      new Campaign(this.$api).load(id)
    },
    onSave() {
      // if (!this.activeCampaign.name) {
      //   this.$refs.dialog.show({
      //     // type: 'info',
      //     type: 'warning',
      //     title: this.$t('MAILING_ENTER_NAME_TITLE'),
      //     message: this.$t('MAILING_ENTER_NAME'),
      //     // buttons: ['save', 'discard', 'cancel']
      //   })
      //   return
      // }
      this.$store.commit('setActiveCampaign', this.activeCampaign)
      if (!this.activeCampaign.campaign_id) {
        new Campaign(this.$api).create(this.selectedCampaignFolder)
        .then(() => {
          this.dirty = false
          new Folder(this.$api).list()
          new Campaign(this.$api).list()
        })
      } else {
        new Campaign(this.$api).update()
        .then(() => {
          this.dirty = false
          new Folder(this.$api).list()
          new Campaign(this.$api).list()
        })
      }
    },
    onLeave(next) {
      if (this.dirty) {
        next(false)
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: () => {
                this.onSave()
                next()
              },
            },
            {
              label: this.$t('GENERIC_DISCARD'),
              close: true,
              default: true,
              callback: () => {
                next()
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })

      } else {
        next()
      }
    },
    appReload(e) {
      if (this.dirty) {
        e.preventDefault()
        e.returnValue = 'Please save' // Chrome only
        return 'Please save' // legacy
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
// console.log('beforeRouteUpdate')
    this.onLeave(next)
  },
  beforeRouteLeave(to, from, next) {
// console.log('beforeRouteLeave')
    this.onLeave(next)
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.appReload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.appReload)
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>
.campaign-range {
  min-width: 200px;
}
</style>
